import { UrlConstants } from '../constants/url.constants';

export class OrderService {
  static host = UrlConstants.backend;

  static getToken() {
    return localStorage.getItem('token');
  }

  static async fetchOrders() {
    const apiPath = '/fetch-orders';
    try {
      const token = this.getToken();
      const response = await fetch(`${this.host}${apiPath}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch orders');
      }

      const data = await response.json();

      return data;
    } catch (error) {
      console.error('Error fetching orders:', error);
      throw error;
    }
  }

  static async updateOrderStatus(orderId, orderStatus) {
    const apiPath = `/status/${orderId}`;
    try {
      const token = this.getToken();
      const response = await fetch(`${this.host}${apiPath}`, {
        method: 'PATCH',
        body: JSON.stringify({ orderStatus: orderStatus }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to update order status');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error updating order status:', error);
      throw error;
    }
  }
}
